import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
    MSAL_GUARD_CONFIG,
    MSAL_INSTANCE,
    MSAL_INTERCEPTOR_CONFIG,
    MsalGuardConfiguration,
    MsalInterceptorConfiguration
} from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../../../environments/environment';

// Configure the MSAL guard for route protection
export const msalGuardConfigFactory = (): MsalGuardConfiguration => ({
    interactionType: InteractionType.Redirect,
    authRequest: { scopes: [...environment.apiConfig[1].scopes] }
});

// Configure which API requests should have tokens attached, no need of token-injector-interceptor, so it is extremely important that you add your apiUrl to environment.apiConfig.uri
export const msalInterceptorConfigFactory = (): MsalInterceptorConfiguration => {
    const protectedResourceMap = new Map<string, string[]>();
    for (const item of environment.apiConfig) {
        protectedResourceMap.set(item.uri, item.scopes);
    }
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
};

export const provideMsalConfiguration = (): EnvironmentProviders =>
    makeEnvironmentProviders([
        { provide: MSAL_INSTANCE, useFactory: () => new PublicClientApplication(environment.msalConfig) },
        { provide: MSAL_GUARD_CONFIG, useFactory: msalGuardConfigFactory },
        { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: msalInterceptorConfigFactory }
    ]);
